import { Link, usePage } from "@inertiajs/react"
import { Monitor, Smartphone } from "lucide-react"

import { usePwaFormFactor } from "@/hooks/use-pwa-form-factor"
import { useStandaloneDisplay } from "@/hooks/use-standalone-display"
import { pwaInstallPath } from "@/lib/pwa-device"
import { memberInstallPath } from "@/routes"
import type { SharedData } from "@/types"

export function InstallAppLinks() {
  const page = usePage<SharedData>()
  const { auth } = page.props
  const standalone = useStandaloneDisplay()
  const formFactor = usePwaFormFactor()
  const currentPath = page.url.split(/[?#]/, 1)[0]
  const onInstallPage = currentPath === memberInstallPath()

  if (standalone || onInstallPage || !auth?.user || !formFactor) return null

  const alreadyInstalled =
    formFactor === "mobile"
      ? auth.user.has_mobile_pwa_device === true
      : auth.user.has_desktop_pwa_device === true
  if (alreadyInstalled) return null

  const Icon = formFactor === "mobile" ? Smartphone : Monitor
  const label = formFactor === "mobile" ? "Install Mobile" : "Install Desktop app"

  return (
    <Link
      href={pwaInstallPath(formFactor)}
      className="text-foreground inline-flex items-center gap-1.5 text-sm font-medium underline-offset-4 hover:underline"
    >
      <Icon className="size-4" />
      {label}
    </Link>
  )
}
